import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Billable months for a fixed term; the end date is inclusive (Nov 1 → Jan 31 = 3 months).
export function termMonths(startIso, endIso) {
  if (!startIso || !endIso) return null;
  const [sy, sm, sd] = startIso.slice(0, 10).split("-").map(Number);
  const [ey, em, ed] = endIso.slice(0, 10).split("-").map(Number);
  if (!sy || !ey) return null;
  const s = new Date(sy, sm - 1, sd);
  const e = new Date(ey, em - 1, ed + 1);
  if (e <= s) return null;
  let months = (e.getFullYear() - s.getFullYear()) * 12 + (e.getMonth() - s.getMonth());
  if (e.getDate() < s.getDate()) months -= 1;
  return Math.max(1, months);
}
